import { render } from "./paySuccessQp.vue?vue&type=template&id=55af1424&scoped=true"
import script from "./paySuccessQp.vue?vue&type=script&lang=js"
export * from "./paySuccessQp.vue?vue&type=script&lang=js"

import "./paySuccessQp.vue?vue&type=style&index=0&id=55af1424&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-55af1424"

export default script